import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, tap } from 'rxjs';
import { BpService } from '../../../core/services/bp.service';
import { SelectTariffSignatureForm } from './sign-selected-tariff-page.model';
import { KkmsApiService } from '../../../core/modules/kkms/kkms-api.service';

@Component({
  selector: 'tax-sign-selected-tariff-page',
  templateUrl: 'sign-selected-tariff-page.component.html',
  styleUrls: ['sign-selected-tariff-page.component.sass'],
})

export class SignSelectedTariffPageComponent {
  link?: SafeResourceUrl;
  readonly processForm$ = this.getForm();

  constructor(
    private bpService: BpService,
    private kkmsApiService: KkmsApiService,
    private sanitizer: DomSanitizer,
  ) {}

  getForm(): Observable<SelectTariffSignatureForm> {
    return this.bpService.getCurrentBpFormData<SelectTariffSignatureForm>()
      .pipe(tap(() => {
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(
          `${this.kkmsApiService.fetchLinkToPdfKKkmChangeStatusDocument(
            this.bpService.getProcessIds().pid,
          )}#toolbar=0&amp;navpanes=0`,
        );
      }));
  }
}
